import { Box, classSet, Modal } from '@platform/ui-library';
import { FC, ReactNode, useState } from 'react';
import { LoginCodeForm } from './login-code-form';
import { LoginPasswordForm } from './login-password-form';
import { LoginState } from './login-state';

export type LoginModalProps = {
  onComplete: () => void;
};

export const LoginModal: FC<LoginModalProps> = ({ onComplete }) => {
  const [state, setState] = useState<LoginState>({
    enableRememberMe: false,
    password: '',
    username: '',
    validUsernameAndPassword: false
  });

  const backdropClass = (location.pathname.startsWith('/home')) ? (
    'ui-modal-hide-backdrop'
  ) : null;

  let content: ReactNode;
  content = (!state.validUsernameAndPassword) ? (
    <LoginPasswordForm
      onComplete={onComplete}
      setState={setState}
      state={state}
    />
  ) : (
    <LoginCodeForm
      onComplete={onComplete}
      setState={setState}
      state={state}
    />
  );

  return (
    <Modal className={classSet(['loginModal', backdropClass])} isOpen>
      <Box theme='noPadding'>
        {content}
      </Box>
    </Modal>
  );
};
